module.exports = __webpack_public_path__ + "media/images/plans/e-photo_studio/pickup-1-7d791eafa6405caa8e07dab7a031a30e.png";